import { ITranslations } from 'types/common';
import en from 'translations/en/pointCategoryBasicForm.json';
import pl from 'translations/pl/pointCategoryBasicForm.json';
import sl from 'translations/sl/pointCategoryBasicForm.json';
import { PointCategoryBasicFormTransFields } from './types';

export const pointCategoryBasicFormTranslations: ITranslations<PointCategoryBasicFormTransFields> = {
  name: 'pointCategoryBasicForm',
  en,
  pl,
  sl,
};
